import { LegalSection } from "@/components/legal/LegalSection";

export const WhatAreCookies = () => (
  <LegalSection id="what-are-cookies" title="What Are Cookies">
    <p>
      Cookies are small text files that are stored on your device (computer,
      smartphone, tablet) when you visit a website. They help websites remember
      your preferences, login status, and other information to enhance your
      browsing experience.
    </p>

    <h3>Similar Technologies</h3>
    <p>
      In addition to cookies, we may use other similar technologies including:
    </p>
    <ul>
      <li>
        <strong>Web Beacons:</strong> Small graphic images that track user
        behavior
      </li>
      <li>
        <strong>Local Storage:</strong> Data stored locally on your device
      </li>
      <li>
        <strong>Session Storage:</strong> Temporary data that expires when you
        close your browser
      </li>
      <li>
        <strong>Pixels:</strong> Tracking codes that monitor user interactions
      </li>
    </ul>
  </LegalSection>
);

export const TypesOfCookies = () => (
  <LegalSection id="types-of-cookies" title="Types of Cookies We Use">
    <h3>Essential Cookies</h3>
    <p>
      These cookies are necessary for the website to function properly. They
      enable core functionality such as security, network management, and
      accessibility. Without these cookies, our services cannot be provided.
    </p>
    <ul>
      <li>Authentication and login session management</li>
      <li>Security features and fraud prevention</li>
      <li>Load balancing and server routing</li>
      <li>Basic website functionality</li>
    </ul>

    <h3>Performance and Analytics Cookies</h3>
    <p>
      These cookies help us understand how visitors interact with our website by
      collecting and reporting information anonymously. This helps us improve
      our website's performance and user experience.
    </p>
    <ul>
      <li>Page visit statistics and user journey tracking</li>
      <li>Error reporting and website optimization</li>
      <li>Performance monitoring and loading times</li>
      <li>Feature usage analytics</li>
    </ul>

    <h3>Functional Cookies</h3>
    <p>
      These cookies enable enhanced functionality and personalization. They may
      be set by us or by third-party providers whose services we use on our
      pages.
    </p>
    <ul>
      <li>Language and region preferences</li>
      <li>User interface customizations</li>
      <li>Content recommendations</li>
      <li>Social media integrations</li>
    </ul>

    <h3>Marketing and Advertising Cookies</h3>
    <p>
      These cookies are used to deliver relevant advertisements and track
      advertising campaign effectiveness. They help us show you ads that are
      more likely to be of interest to you.
    </p>
    <ul>
      <li>Targeted advertising and retargeting</li>
      <li>Ad performance measurement</li>
      <li>Cross-device tracking</li>
      <li>Audience segmentation</li>
    </ul>
  </LegalSection>
);
